import AlgorithmVisualizer from "./naive-string-matching"

export default function Ns() {
  return (
    <div style={{ background: '#0d1b2a', minHeight: '100vh', width: '100%' }}>
      <AlgorithmVisualizer />
    </div>
  )
}
